import { c as _c } from "react/compiler-runtime";
import { Router } from 'next/router';
import { useEffect } from 'react';
declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}
const useGTMPageviews = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
};
export { useGTMPageviews };
function _temp(url) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "pageview",
    page: url
  });
}
function _temp2() {
  if (typeof window === "undefined") {
    return;
  }
  const push = _temp;
  const handleRouteChange = url_0 => push(url_0);
  Router.events.on("routeChangeComplete", handleRouteChange);
  return () => {
    Router.events.off("routeChangeComplete", handleRouteChange);
  };
}